import { IThunkApi } from '../../../types/redux';
import { fetchConfirmInsuranceActivation } from '../../../services/activateInsurance/fetchConfirmInsuranceActivation';
import { createAsyncThunk } from '@reduxjs/toolkit';

const DEFAULT_ERROR = 'Не получилось, попробуйте ещё раз';

interface IThunkApiWithTypedReject extends IThunkApi {
  rejectValue: string;
}

interface IParams {
  onSuccess?: VoidFunction;
}

export const confirmInsuranceActivation = createAsyncThunk<void, IParams, IThunkApiWithTypedReject>(
  'activateInsurance/confirmInsuranceActivation',
  async (params, thunkApi) => {
    const { rejectWithValue, extra: context } = thunkApi;

    try {
      await fetchConfirmInsuranceActivation(context);
      params?.onSuccess?.();

      return;
    } catch (e) {
      return rejectWithValue(e.message || DEFAULT_ERROR);
    }
  },
);
